module.exports = __webpack_public_path__ + "static/media/pingdom-logo-simple.bcdf05d6.svg";